var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 4.968 6 0 7.03 1.032 2.063 6l4.968 4.968L5.999 12 1.03 7.032-.001 6l1.032-1.032Z",
    fill: "#333"
  })));
};
export { SvgBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjAzMDk0IDQuOTY3NzRMNS45OTg2OCAwTDcuMDMwOTQgMS4wMzIyNkwyLjA2MzIgNkw3LjAzMDk0IDEwLjk2NzdMNS45OTg2OCAxMkwxLjAzMDk0IDcuMDMyMjZMLTAuMDAwOTc2NTYzIDUuOTk5NjFMMS4wMzA5NCA0Ljk2Nzc0WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";